import Accordion from './Accordion';
import { eventTypes } from '../config/vars';

//import {triggerEvent} from '../lib/helper';

export default class AccordionRadioBtn extends Accordion {

  constructor(el) {

    super(el);
    this.el = el;
    this.input = this.el.querySelector('input[type="radio"]');
    this.fields = [].slice.call(this.content.querySelectorAll('.formfield-wrapper input, .formfield-wrapper select, .formfield-wrapper textarea'));

    if (this.fields.length > 0) {

      this.focusOnTransitionEndHandler = this.focusOnTransitionEnd.bind(this);
      eventTypes['transitionEnd'].map( transitionEndEvent => {

        this.content.addEventListener(transitionEndEvent, this.focusOnTransitionEndHandler);
      });
    }

    this.removeStandardEvents();
    this.checkInitialState();

    this.triggerArr[0].addEventListener('change', this.handeCheckedState.bind(this), false);
  }

  checkInitialState() {

    if (this.input.checked) {

      this.enableFields();
      this.open();
    } else {

      this.disableFields();
    }
  }

  handeCheckedState(e) {

    if (this.isOpen || !this.input.checked) {

      this.disableFields();
      this.close();
    } else {

      this.enableFields();
      this.open();
      // this.el.scrollIntoView(true);
    }
  }

  enableFields() {

    this.fields.map(field => {

      field.disabled = false;
      return field;
    });
  }

  disableFields() {

    this.fields.map(field => {

      field.disabled = true;
      return field;
    });
  }

  focusOnTransitionEnd(e) {

    if (e.propertyName == 'visibility') {

      this.fields[0].focus();
    }
  }

  open(trigger) {

    this.enableFields();
    super.open(trigger);
  }

  close(trigger) {

    this.disableFields();
    super.close(trigger);
  }

};
